
import {
  Component,
  Inject,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import Clickoutside from "@/views/ai-builder-component/plugins/clickoutside";
import { ElForm } from "element-ui/types/form";
import Color from "@/views/ai-builder-component/utils/colorHelper";
import PickerDropdown from "./picker-dropdown.vue";

@Component({
  directives: {
    Clickoutside
  },
  components: {
    PickerDropdown
  }
})
export default class HinaColorPicker extends Vue {
  @Inject({ default: "" }) readonly elForm!: ElForm;
  @Model("change") private readonly value!: string;
  @Prop({ default: false }) private disabled!: boolean;

  showPanelColor = false;
  showPicker = false;
  color: Color = new Color();

  @Watch("value")
  changeValue(value: string) {
    if (/^#{1}[0-9a-fA-F]{0,6}$/.test(value)) {
      this.color.value = value;
    } else {
      this.color.value = "";
    }
  }

  get colorDisabled() {
    return this.disabled || (this.elForm || {}).disabled;
  }

  get currentColor() {
    return this.color.value;
  }

  changeInput(val: string) {
    if (/^#{1}[0-9a-fA-F]{0,6}$/.test(val)) {
      this.color.value = val;
    } else {
      this.color.value = "";
    }
  }

  hide() {
    this.showPicker = false;
    this.resetColor();
  }

  resetColor() {
    this.$nextTick(_ => {
      if (
        this.value &&
        (/^#{1}[0-9a-fA-F]{3}$/.test(this.value) ||
          /^#{1}[0-9a-fA-F]{6}$/.test(this.value))
      ) {
        this.color?.fromString(this.value);
      } else {
        this.color.value = "";
        this.showPanelColor = false;
      }
    });
  }

  handleTrigger() {
    if (this.colorDisabled) return;
    this.showPicker = !this.showPicker;
  }

  @Watch("currentColor")
  changeColor(val: string) {
    this.$emit("change", val);
  }
}
